import { render, staticRenderFns } from "./ConnectWalletModal.vue?vue&type=template&id=653b2322"
import script from "./ConnectWalletModal.vue?vue&type=script&lang=ts"
export * from "./ConnectWalletModal.vue?vue&type=script&lang=ts"
import style0 from "./ConnectWalletModal.vue?vue&type=style&index=0&id=653b2322&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports